export default __webpack_public_path__ + "static/media/guide_960.a31e4995.webp";